import { useState, useEffect } from 'react';

/**
 * @param {boolean} isLoading - текущее состояние загрузки (например, из useAuth или useState).
 * @param {number} minDelay - минимальное время показа загрузки в мс (по умолчанию 800).
 */
export function useDelayedLoading(isLoading, minDelay = 800) {
  const [delayedLoading, setDelayedLoading] = useState(true);

  useEffect(() => {
    let timeout;

    if (isLoading) {
      setDelayedLoading(true);
    } else {
      timeout = setTimeout(() => {
        setDelayedLoading(false);
      }, minDelay);
    }

    return () => clearTimeout(timeout);
  }, [isLoading, minDelay]);

  return delayedLoading;
}
